<div [class]="styleClass">
  <div class="w-full h-full flex items-center justify-center">
    <p-progressSpinner [styleClass]="isSmall ? 'w-10 h-10' : 'w-18 h-18'" strokeWidth="3"></p-progressSpinner>
  </div>
</div>
